var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _rect, _rect2, _rect3, _rect4, _path36, _rect5, _rect6, _rect7, _rect8, _path37, _rect9, _rect0, _path38, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path39, _path40, _rect16, _rect17, _path41, _path42, _rect18, _rect19, _rect20, _rect21, _path43, _rect22, _path44, _path45, _path46, _path47, _path48, _rect23, _rect24, _rect25, _rect26, _path49, _rect27, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickCalculatorStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 449,
    viewBox: "0 0 480 449",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0262 398.249H0.490234V398.516H14.0262V398.249Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.058 84.532H4.62891V315.337H146.058V84.532Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.378 84.532H6.64453V315.337H150.378V84.532Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.058 315.337H4.62891V321.876H146.058V315.337Z",
    fill: "#E6E6E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M157.567 315.337H13.834V321.876H157.567V315.337Z",
    fill: "#F0F0F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144.33 309.289V90.5693L12.6821 90.5693V309.289H144.33Z",
    fill: "#FAFAFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3672 309.289L59.1885 90.5693H85.4285L68.6072 309.289H42.3672Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4876 303.273C15.4307 303.275 15.374 303.265 15.321 303.244C15.268 303.223 15.2197 303.192 15.179 303.152C15.1382 303.112 15.1058 303.065 15.0837 303.012C15.0616 302.96 15.0502 302.904 15.0503 302.847V94.5054C15.0404 94.4429 15.0442 94.3791 15.0614 94.3183C15.0786 94.2575 15.1088 94.2012 15.1498 94.1531C15.1909 94.1051 15.2418 94.0665 15.2992 94.0401C15.3566 94.0136 15.4191 93.9999 15.4823 93.9999C15.5454 93.9999 15.6079 94.0136 15.6653 94.0401C15.7227 94.0665 15.7736 94.1051 15.8147 94.1531C15.8558 94.2012 15.8859 94.2575 15.9031 94.3183C15.9203 94.3791 15.9241 94.4429 15.9143 94.5054V302.847C15.9143 302.903 15.9032 302.958 15.8818 303.01C15.8603 303.062 15.8289 303.109 15.7893 303.148C15.7497 303.188 15.7026 303.219 15.6509 303.241C15.5991 303.262 15.5436 303.273 15.4876 303.273Z",
    fill: "#F0F0F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.25 309.289L91.0607 90.5693H101.29L84.4793 309.289H74.25Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M144.33 309.289V90.5693H143.562V309.289H144.33Z",
    fill: "#E6E6E6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M151.807 99.6787H10.3778L9.8125 92.9161H151.253L151.807 99.6787Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M151.807 110.772H10.3778L9.8125 104.009H151.253L151.807 110.772Z",
    fill: "#EBEBEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M151.807 121.855H10.3778L9.8125 115.092H151.253L151.807 121.855Z",
    fill: "#EBEBEB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M151.807 132.948H10.3778L9.8125 126.185H151.253L151.807 132.948Z",
    fill: "#EBEBEB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M151.807 144.031H10.3778L9.8125 137.268H151.253L151.807 144.031Z",
    fill: "#EBEBEB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M151.807 155.124H10.3778L9.8125 148.361H151.253L151.807 155.124Z",
    fill: "#EBEBEB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M479.168 224.607H430.901L435.179 168.127H474.891L479.168 224.607Z",
    fill: "#fad504"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M468.575 224.607H460.277L458.517 168.127H466.175L468.575 224.607Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M457.45 224.607H452.618V381.727H457.45V224.607Z",
    fill: "#fad504"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M457.408 294.964H452.662C451.483 294.964 450.528 295.919 450.528 297.097V301.844C450.528 303.022 451.483 303.977 452.662 303.977H457.408C458.587 303.977 459.542 303.022 459.542 301.844V297.097C459.542 295.919 458.587 294.964 457.408 294.964Z",
    fill: "#FFE511"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M457.408 309.407H452.662C451.483 309.407 450.528 310.362 450.528 311.54V316.287C450.528 317.465 451.483 318.42 452.662 318.42H457.408C458.587 318.42 459.542 317.465 459.542 316.287V311.54C459.542 310.362 458.587 309.407 457.408 309.407Z",
    fill: "#FFE511"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M462.677 381.727H447.392C447.391 380.872 447.727 380.051 448.325 379.441C448.923 378.831 449.737 378.48 450.592 378.463H459.37C460.225 378.48 461.039 378.831 461.637 379.441C462.235 380.051 462.57 380.872 462.57 381.727H462.677Z",
    fill: "#FFBF1A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M457.45 224.607H452.618V227.561H457.45V224.607Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M253.867 437.364C368.088 437.364 460.683 431.958 460.683 425.289C460.683 418.621 368.088 413.215 253.867 413.215C139.645 413.215 47.0508 418.621 47.0508 425.289C47.0508 431.958 139.645 437.364 253.867 437.364Z",
    fill: "#F5F5F5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M361.48 378.538H396.744V274.644H361.48V378.538Z",
    fill: "#F0F0F0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M165.203 381.727H394.365V378.537H165.203V381.727Z",
    fill: "#F0F0F0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M361.48 274.644H162.824V378.538H361.48V274.644Z",
    fill: "#F5F5F5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M347.602 315.594H176.68V337.588H347.602V315.594Z",
    fill: "#F0F0F0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M347.602 343.914H176.68V365.908H347.602V343.914Z",
    fill: "#F0F0F0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M223.869 319.434H300.424C301.053 319.431 301.655 319.179 302.099 318.733C302.543 318.287 302.792 317.684 302.792 317.055C302.789 316.428 302.538 315.827 302.095 315.384C301.651 314.94 301.051 314.69 300.424 314.687H223.869C223.242 314.69 222.641 314.94 222.198 315.384C221.754 315.827 221.504 316.428 221.501 317.055C221.501 317.684 221.75 318.287 222.194 318.733C222.638 319.179 223.24 319.431 223.869 319.434Z",
    fill: "#F5F5F5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M347.602 287.284H176.68V309.279H347.602V287.284Z",
    fill: "#F0F0F0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M223.869 291.071H300.424C301.051 291.068 301.651 290.818 302.095 290.374C302.538 289.931 302.789 289.33 302.792 288.703C302.792 288.074 302.543 287.47 302.099 287.025C301.655 286.579 301.053 286.327 300.424 286.324H223.869C223.24 286.327 222.638 286.579 222.194 287.025C221.75 287.47 221.501 288.074 221.501 288.703C221.504 289.33 221.754 289.931 222.198 290.374C222.641 290.818 223.242 291.068 223.869 291.071Z",
    fill: "#F5F5F5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M223.869 347.7H300.424C301.051 347.698 301.651 347.447 302.095 347.004C302.538 346.56 302.789 345.96 302.792 345.332C302.792 344.703 302.543 344.1 302.099 343.654C301.655 343.208 301.053 342.957 300.424 342.954H223.869C223.24 342.957 222.638 343.208 222.194 343.654C221.75 344.1 221.501 344.703 221.501 345.332C221.504 345.96 221.754 346.56 222.198 347.004C222.641 347.447 223.242 347.698 223.869 347.7Z",
    fill: "#F5F5F5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M159.698 274.655H361.479V271.69H159.698V274.655Z",
    fill: "#F0F0F0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M400.093 271.679H361.469V274.644H400.093V271.679Z",
    fill: "#E6E6E6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0463 46.23H252.265V193.994C252.265 195.421 251.298 196.789 249.577 197.798C247.857 198.807 245.523 199.373 243.089 199.373H80.1073C77.6737 199.373 75.3399 198.807 73.6191 197.798C71.8983 196.789 70.9316 195.421 70.9316 193.994V46.23H71.0463Z",
    fill: "#EDF3F7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9507 20.584H240.267C243.43 20.584 246.464 21.8407 248.701 24.0777C250.938 26.3147 252.195 29.3487 252.195 32.5123V46.2758H70.9766V32.5123C70.9766 30.942 71.2866 29.3871 71.8889 27.9369C72.4913 26.4867 73.374 25.1697 74.4865 24.0615C75.599 22.9532 76.9194 22.0756 78.3719 21.4788C79.8244 20.8821 81.3804 20.578 82.9507 20.584Z",
    fill: "#2771bb"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 167.225,
    y: 77.1594,
    width: 20.6238,
    height: 86.4794,
    fill: "#CCE0F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20.0379,
    height: 37.0289,
    transform: "matrix(-1 0 0 1 207.887 87.4709)",
    fill: "#B2D1F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 30.5468,
    height: 13.1242,
    transform: "matrix(-1 0 0 1 218.395 124.5)",
    fill: "#90BBE5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 232.729,
    y: 163.639,
    width: 44.8802,
    height: 26.0141,
    transform: "rotate(-180 232.729 163.639)",
    fill: "#B2D1F0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M237.415 163.639H192.535",
    stroke: "#2771bb",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 46.5208,
    height: 9.726,
    transform: "matrix(-1 0 0 1 167.225 87.4709)",
    fill: "#B2D1F0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 9.02292,
    height: 7.14803,
    transform: "matrix(-1 0 0 1 202.378 92.6271)",
    fill: "#2771bb"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 167.225,
    y: 117.352,
    width: 39.8414,
    height: 20.1551,
    transform: "rotate(-180 167.225 117.352)",
    fill: "#90BBE6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 167.225,
    y: 163.639,
    width: 33.4844,
    height: 46.2864,
    transform: "rotate(-180 167.225 163.639)",
    fill: "#90BBE5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.954 137.624H158.086V111.844H91.1758V137.624H91.176V163.639H146.954V137.624Z",
    fill: "#CCE0F5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 133.739,
    y: 163.639,
    width: 13.2121,
    height: 26.0141,
    transform: "rotate(-180 133.739 163.639)",
    fill: "#2771bb"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 148.331,
    y: 163.639,
    width: 13.2121,
    height: 26.0141,
    transform: "rotate(-180 148.331 163.639)",
    fill: "#2771bb"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M237.178 163.639H85.7845",
    stroke: "#2771bb",
    strokeWidth: 1.5
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 147.772,
    y: 130.828,
    width: 46.2864,
    height: 9.49162,
    transform: "rotate(-180 147.772 130.828)",
    fill: "#2771bb"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 159.257,
    y: 107.744,
    width: 23.9049,
    height: 5.27313,
    transform: "rotate(-180 159.257 107.744)",
    fill: "#2771bb"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 172.85,
    y: 82.3158,
    width: 9.37448,
    height: 9.37447,
    fill: "#2771bb"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 172.85,
    y: 96.3768,
    width: 9.37448,
    height: 9.37447,
    fill: "#2771bb"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 172.85,
    y: 110.439,
    width: 9.37448,
    height: 9.37446,
    fill: "#2771bb"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 172.85,
    y: 124.5,
    width: 9.37448,
    height: 9.37445,
    fill: "#2771bb"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 172.85,
    y: 138.562,
    width: 9.37448,
    height: 9.37445,
    fill: "#2771bb"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M232.571 136.445H370.249V248.707C370.249 249.791 369.515 250.831 368.207 251.597C366.9 252.364 365.127 252.794 363.278 252.794H239.454C237.606 252.794 235.833 252.364 234.525 251.597C233.218 250.831 232.483 249.791 232.483 248.707V136.445H232.571Z",
    fill: "#F3F7F9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M241.616 116.961H361.135C363.538 116.961 365.843 117.916 367.543 119.615C369.242 121.315 370.197 123.62 370.197 126.023V136.48H232.519V126.023C232.519 124.83 232.754 123.649 233.212 122.547C233.669 121.446 234.34 120.445 235.185 119.603C236.03 118.761 237.034 118.094 238.137 117.641C239.241 117.187 240.423 116.956 241.616 116.961Z",
    fill: "#2771bb"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 290.789,
    y: 156.948,
    width: 46.1894,
    height: 68.6973,
    fill: "#90BBE5"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 264.562,
    y: 174.269,
    width: 50.4954,
    height: 51.3762,
    fill: "#B2D1F0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M344.025 225.645H258.691",
    stroke: "#2771bb",
    strokeWidth: 1.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M290.789 165.951H258.691",
    stroke: "#90BBE5",
    strokeWidth: 1.5
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 264.562,
    y: 165.951,
    width: 8.87256,
    height: 10.5258,
    stroke: "#90BBE5",
    strokeWidth: 1.5
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 273.436,
    y: 165.951,
    width: 8.87262,
    height: 10.5258,
    stroke: "#90BBE5",
    strokeWidth: 1.5
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 282.308,
    y: 165.951,
    width: 8.87262,
    height: 10.5258,
    stroke: "#90BBE5",
    strokeWidth: 1.5
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 274.349,
    y: 211.652,
    width: 11.1559,
    height: 13.9939,
    fill: "#2771bb"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.126 174.269H258.691V180.924H305.077V198.538H258.691V205.193H321.126V174.269Z",
    fill: "#CCE0F5"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 264.562,
    y: 180.924,
    width: 40.5137,
    height: 17.6147,
    fill: "#2771bb"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M192.602 16.3582H299.201V103.278C299.201 104.117 298.632 104.922 297.62 105.516C296.608 106.109 295.235 106.443 293.803 106.443H197.932C196.5 106.443 195.127 106.109 194.115 105.516C193.103 104.922 192.534 104.117 192.534 103.278V16.3582H192.602Z",
    fill: "#F3F7F9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M199.605 1.27221H292.144C294.005 1.27221 295.79 2.01145 297.106 3.32733C298.421 4.64321 299.161 6.42793 299.161 8.28886V16.385H192.562V8.28886C192.562 7.36514 192.744 6.45052 193.098 5.59745C193.453 4.74439 193.972 3.96969 194.626 3.31778C195.281 2.66587 196.057 2.14959 196.912 1.79856C197.766 1.44753 198.681 1.26865 199.605 1.27221Z",
    fill: "#2771bb"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M212.804 49.5393L230.574 33.8192L248.345 49.5393V85.4223H212.804V49.5393Z",
    fill: "#CCE0F5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M221.519 48.5141L230.404 40.6541L239.289 48.5141V54.8364H221.519V48.5141Z",
    fill: "#2771bb"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M210.069 52.2232L230.574 33.8192L251.078 52.2232",
    stroke: "#2771bb",
    strokeWidth: 1.5
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 218.699,
    y: 65.2594,
    width: 4.27176,
    height: 15.0367,
    fill: "#2771bb"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 228.438,
    y: 65.2594,
    width: 4.2718,
    height: 15.0367,
    fill: "#2771bb"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 238.179,
    y: 65.2594,
    width: 4.27179,
    height: 15.0367,
    fill: "#2771bb"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 248.345,
    y: 65.2594,
    width: 30.586,
    height: 20.1628,
    fill: "#B2D1F0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M283.032 85.4222H208.703",
    stroke: "#2771bb",
    strokeWidth: 1.5
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 259.195,
    y: 72.7778,
    width: 8.88533,
    height: 12.6445,
    fill: "#2771bb"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M248.345 65.2594H281.665L277.564 57.143H248.345V65.2594Z",
    fill: "#90BBE5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M374.528 418.879H366.72L366.73 400.777H374.549L374.528 418.879Z",
    fill: "#FFB573"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M437.312 403.935L429.834 406.196L421.6 389.78L429.077 387.519L437.312 403.935Z",
    fill: "#FFB573"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M426.944 407.551C426.449 407.742 425.904 407.761 425.397 407.604C425.233 407.527 425.09 407.409 424.984 407.262C424.877 407.114 424.81 406.942 424.789 406.762C424.764 406.655 424.767 406.543 424.799 406.438C424.831 406.333 424.89 406.239 424.971 406.164C425.675 405.492 428.48 406.26 428.8 406.346C428.834 406.358 428.863 406.38 428.886 406.408C428.908 406.436 428.923 406.47 428.928 406.506C428.93 406.542 428.922 406.577 428.905 406.609C428.888 406.641 428.863 406.668 428.832 406.687C428.238 407.046 427.604 407.336 426.944 407.551ZM425.429 406.324C425.345 406.341 425.267 406.382 425.205 406.442C425.175 406.472 425.154 406.51 425.144 406.551C425.135 406.593 425.138 406.636 425.152 406.676C425.163 406.801 425.207 406.92 425.278 407.023C425.349 407.126 425.445 407.208 425.557 407.263C426.507 407.395 427.47 407.154 428.245 406.591C427.333 406.318 426.376 406.227 425.429 406.324Z",
    fill: "#2771bb"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M428.8 406.708H428.704C427.829 406.516 425.909 405.311 425.845 404.415C425.839 404.274 425.879 404.134 425.96 404.018C426.041 403.903 426.159 403.817 426.293 403.775C426.42 403.714 426.558 403.683 426.699 403.683C426.839 403.683 426.978 403.714 427.104 403.775C428.171 404.223 428.896 406.356 428.928 406.452C428.943 406.482 428.951 406.515 428.951 406.548C428.951 406.581 428.943 406.614 428.928 406.644L428.8 406.708ZM426.507 404.095C426.479 404.086 426.449 404.086 426.421 404.095C426.208 404.191 426.208 404.297 426.208 404.351C426.208 404.873 427.52 405.844 428.437 406.207C428.192 405.588 427.627 404.383 426.955 404.073C426.804 404.025 426.641 404.032 426.496 404.095H426.507Z",
    fill: "#2771bb"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M429.077 405.481L437.482 402.943C437.628 402.898 437.784 402.906 437.924 402.964C438.064 403.022 438.18 403.128 438.25 403.263L441.45 409.556C441.525 409.714 441.565 409.887 441.568 410.062C441.57 410.237 441.534 410.41 441.463 410.57C441.393 410.73 441.288 410.873 441.157 410.989C441.026 411.105 440.871 411.191 440.704 411.241C437.76 412.073 436.288 412.308 432.586 413.449C430.314 414.132 422.986 417.823 419.893 418.783C416.8 419.743 415.541 416.713 416.757 416.031C422.186 413.012 426.57 408.564 427.989 406.324C428.239 405.922 428.625 405.624 429.077 405.481Z",
    fill: "#263238"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M363.499 419.337C362.836 419.403 362.172 419.233 361.621 418.857C361.498 418.747 361.404 418.607 361.35 418.45C361.296 418.293 361.283 418.125 361.312 417.961C361.319 417.858 361.353 417.758 361.411 417.671C361.469 417.585 361.549 417.516 361.643 417.471C362.613 416.937 365.685 418.537 366.027 418.719C366.062 418.735 366.091 418.763 366.109 418.798C366.126 418.833 366.131 418.873 366.123 418.911C366.115 418.949 366.095 418.984 366.066 419.01C366.038 419.037 366.002 419.054 365.963 419.06C365.152 419.232 364.327 419.325 363.499 419.337ZM362.155 417.727C362.034 417.721 361.914 417.743 361.803 417.791C361.768 417.813 361.738 417.842 361.716 417.878C361.694 417.913 361.68 417.952 361.675 417.993C361.66 418.102 361.67 418.212 361.706 418.316C361.741 418.42 361.8 418.514 361.877 418.591C362.336 419.017 363.627 419.081 365.355 418.793C364.358 418.256 363.275 417.895 362.155 417.727Z",
    fill: "#2771bb"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M365.931 419.071H365.856C364.928 418.644 363.136 416.937 363.317 416.073C363.317 415.871 363.52 415.604 364.032 415.561C364.222 415.529 364.416 415.54 364.601 415.593C364.786 415.647 364.956 415.742 365.099 415.871C366.048 416.692 366.166 418.793 366.166 418.889C366.166 418.921 366.158 418.952 366.143 418.98C366.128 419.008 366.107 419.032 366.08 419.049C366.034 419.074 365.982 419.081 365.931 419.071ZM364.16 415.871H364.053C363.712 415.871 363.691 416.041 363.68 416.084C363.574 416.607 364.747 417.94 365.718 418.516C365.672 417.634 365.347 416.79 364.789 416.105C364.612 415.963 364.388 415.891 364.16 415.903V415.871Z",
    fill: "#2771bb"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M366.805 417.972H375.338C375.491 417.97 375.64 418.023 375.757 418.12C375.874 418.218 375.953 418.355 375.978 418.505L377.216 425.46C377.246 425.632 377.237 425.808 377.191 425.976C377.145 426.144 377.063 426.299 376.95 426.432C376.837 426.564 376.696 426.67 376.537 426.742C376.378 426.814 376.206 426.849 376.032 426.847C372.96 426.793 368.565 426.612 364.65 426.612C360.128 426.612 356.202 426.857 350.901 426.857C347.701 426.857 346.944 423.657 348.298 423.327C354.474 421.983 359.466 421.844 364.896 418.58C365.466 418.209 366.125 417.999 366.805 417.972Z",
    fill: "#263238"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M394.602 133.748C393.226 139.465 392.362 146.548 396.192 150.367C396.192 150.367 393.642 156.169 383.018 156.169C373.312 156.169 378.421 150.367 378.421 150.367C384.821 148.852 384.874 140.959 383.968 136.5L394.602 133.748Z",
    fill: "#FFB573"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M366.73 400.788L366.72 410.111H374.538L374.549 400.788H366.73Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M429.077 387.519L421.6 389.791L425.845 398.25L433.333 395.988L429.077 387.519Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M411.819 157.513L401.792 163.273C401.792 163.273 412.309 187.807 411.275 191.775C409.856 197.108 409.141 207.999 406.955 215.071C407.819 216.041 410.741 217.78 411.915 217.737C416.181 209.204 423.136 194.644 422.731 189.705C421.813 178.42 411.819 157.513 411.819 157.513Z",
    fill: "#FFB573"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M406.954 215.071L400.085 217.908L406.976 223.636C406.976 223.636 412.906 220.959 411.818 215.924L406.954 215.071Z",
    fill: "#FFB573"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M396.245 224.052L402.741 228.927L406.976 223.636L400.085 217.908L396.245 224.052Z",
    fill: "#FFB573"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M410.112 152.137C417.386 153.62 423.296 179.604 423.296 179.604L406.912 187.487C406.912 187.487 401.301 174.964 398.826 165.769C396.245 156.127 402.304 150.548 410.112 152.137Z",
    fill: "#2771bb"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M404.267 161.076C401.216 157.876 402.603 170.612 403.371 179.081C404.021 180.767 404.651 182.281 405.195 183.572C409.6 177.193 408.533 165.556 404.267 161.076Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M378.667 152.735C378.667 149.961 378.262 148.649 379.019 147.625C379.776 146.601 394.795 145.385 397.387 146.559C398.272 146.953 398.784 150.943 397.675 152.724C396.054 155.305 378.667 152.735 378.667 152.735Z",
    fill: "#2771bb"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M378.667 152.735C378.667 149.961 378.262 148.649 379.019 147.625C379.776 146.601 394.795 145.385 397.387 146.559C398.272 146.953 398.784 150.943 397.675 152.724C396.054 155.305 378.667 152.735 378.667 152.735Z",
    fill: "#fad504"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M366.303 152.543C366.303 152.543 356.042 176.137 362.869 220.084H404.671C405.237 213.684 402.538 182.367 410.111 152.137C405.515 151.244 400.865 150.652 396.191 150.367C390.273 150.025 384.339 150.025 378.421 150.367C374.332 150.779 370.281 151.507 366.303 152.543Z",
    fill: "#2771bb"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M372.266 163.508L361.909 159.337C361.909 159.337 347.914 183.103 344.992 185.097C338.218 181.385 335.946 182.889 330.677 178.996C329.344 179.135 327.264 180.991 326.56 181.94C330.826 190.153 345.002 200.319 352.01 194.121C360.682 186.452 372.266 163.508 372.266 163.508Z",
    fill: "#FFB573"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M373.568 160.692C372.011 156.681 368.747 155.007 365.216 155.593C363.659 160.511 360.949 171.316 360.565 187.593L364.619 188.511C364.619 188.511 376.245 167.551 373.568 160.692Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M375.35 157.887C377.675 164.884 363.424 185.471 363.424 185.471L348.171 176.937C350.808 170.516 354.104 164.386 358.006 158.644C363.904 150.441 372.8 150.217 375.35 157.887Z",
    fill: "#2771bb"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M330.933 179.22L323.967 175.199L319.893 183.305C322.708 184.233 325.654 184.697 328.618 184.681L330.933 179.22Z",
    fill: "#FFB573"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M320.533 175.199L315.552 179.935L319.893 183.305L323.968 175.199H320.533Z",
    fill: "#FFB573"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M377.28 125.524C377.216 126.153 376.832 126.591 376.426 126.591C376.021 126.591 375.733 126.036 375.797 125.407C375.861 124.777 376.245 124.34 376.661 124.34C377.077 124.34 377.344 124.895 377.28 125.524Z",
    fill: "#263238"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M377.834 125.577C376.891 127.462 375.7 129.213 374.293 130.783C374.698 131.117 375.172 131.357 375.682 131.484C376.191 131.612 376.722 131.623 377.237 131.519L377.834 125.577Z",
    fill: "#ED893E"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M376.533 123.348L376.373 123.284C376.334 123.256 376.3 123.221 376.274 123.18C376.248 123.139 376.231 123.094 376.223 123.046C376.215 122.998 376.216 122.95 376.228 122.903C376.239 122.855 376.259 122.811 376.288 122.772C376.623 122.269 377.069 121.85 377.593 121.549C378.117 121.247 378.703 121.071 379.307 121.033C379.354 121.035 379.401 121.046 379.445 121.065C379.488 121.085 379.527 121.112 379.56 121.147C379.593 121.182 379.618 121.223 379.635 121.267C379.652 121.312 379.66 121.359 379.659 121.407C379.653 121.506 379.611 121.599 379.54 121.669C379.468 121.738 379.374 121.778 379.275 121.78C378.803 121.819 378.347 121.966 377.942 122.211C377.537 122.455 377.193 122.789 376.939 123.188C376.894 123.252 376.832 123.301 376.76 123.329C376.688 123.358 376.609 123.364 376.533 123.348Z",
    fill: "#263238"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M398.517 124.98C397.248 132.681 396.907 137.236 392.608 140.98C391.243 142.216 389.564 143.051 387.755 143.395C385.946 143.738 384.078 143.576 382.355 142.927C380.632 142.278 379.121 141.166 377.989 139.714C376.857 138.262 376.146 136.527 375.936 134.697C374.987 127.657 377.205 116.255 385.067 113.609C386.747 112.993 388.56 112.833 390.322 113.145C392.083 113.457 393.731 114.229 395.098 115.385C396.464 116.54 397.5 118.036 398.101 119.721C398.702 121.407 398.845 123.221 398.517 124.98Z",
    fill: "#FFB573"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M382.464 128.297C380.864 123.231 378.784 115.401 384.469 112.5C390.154 109.599 394.634 113.631 400.832 117.364C407.818 121.567 403.552 134.9 395.125 138.036C388.053 140.671 381.152 135.38 382.464 128.297Z",
    fill: "#263238"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M383.083 118.9C378.07 120.255 374.613 117.033 377.088 113.321C380.224 108.596 392.555 109.833 397.174 114.943C401.792 120.052 386.56 122.495 383.083 118.9Z",
    fill: "#263238"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M384.991 115.167C378.869 114.036 376.362 109.044 381.493 105.951C386.335 103.039 399.946 108.084 402.218 116.127C404.49 124.169 386.847 120.873 384.991 115.167Z",
    fill: "#263238"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M401.312 118.996C402.24 118.249 405.93 117.183 406.346 121.311C405 119.96 403.213 119.139 401.312 118.996Z",
    fill: "#263238"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M403.957 113.855C404.693 114.793 405.738 118.484 401.6 118.879C402.96 117.539 403.796 115.757 403.957 113.855Z",
    fill: "#263238"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M386.869 127.945C386.312 129.609 385.141 130.998 383.594 131.828C381.546 132.895 380.128 131.209 380.394 129.033C380.618 127.081 381.952 124.159 384.16 123.988C386.368 123.817 387.541 125.908 386.869 127.945Z",
    fill: "#FFB573"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M377.695 220.084C377.695 220.084 383.935 279.817 387.818 302.217C392.085 326.751 421.951 397.577 421.951 397.577L435.658 393.439C435.658 393.439 414.325 328.319 412.309 304.063C410.175 277.727 404.714 220.116 404.714 220.116L377.695 220.084Z",
    fill: "#263238"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M387.306 240.969C386.688 240.031 386.101 239.711 385.536 239.903H385.429C385.298 239.955 385.176 240.027 385.066 240.116C384.952 240.211 384.845 240.314 384.746 240.425C384.682 240.489 384.629 240.564 384.565 240.639C384.501 240.713 384.405 240.863 384.319 240.991C384.126 241.303 383.951 241.628 383.797 241.961C383.712 242.164 383.616 242.377 383.53 242.591C383.445 242.804 383.317 243.135 383.21 243.433C383.104 243.732 382.933 244.244 382.805 244.681C382.805 244.799 382.73 244.905 382.698 245.023C382.666 245.14 382.559 245.513 382.485 245.759L382.325 246.399C382.208 246.825 382.101 247.252 381.994 247.7C381.888 248.148 381.781 248.671 381.674 249.172C381.674 249.343 381.6 249.524 381.557 249.695C381.429 250.335 381.301 250.996 381.173 251.657C382.89 266.527 384.949 283.572 386.741 295.465C386.869 295.081 386.997 294.676 387.125 294.239C387.675 292.258 388.12 290.25 388.458 288.223C391.114 272.895 391.317 247.081 387.306 240.969Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M362.869 220.084C362.869 220.084 359.221 278.516 359.018 302.356C358.805 327.145 363.893 408.308 363.893 408.308H377.13C377.13 408.308 381.13 328.596 382.794 304.244C384.597 277.705 390.346 220.084 390.346 220.084H362.869Z",
    fill: "#263238"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M378.186 404.255C378.24 404.255 377.994 408.575 377.994 408.575H362.73L362.304 403.721L378.186 404.255Z",
    fill: "#2771bb"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M434.57 388.575C434.912 389.247 436.362 393.46 436.362 393.46L421.333 398.015L418.869 393.961L434.57 388.575Z",
    fill: "#2771bb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickCalculatorStep3);
export default __webpack_public_path__ + "static/media/quick-calculator-step-3.f775df2f43b53905ed9f52a6cc52f740.svg";
export { ForwardRef as ReactComponent };